import Vue from 'vue'
import App from './App.vue'
import firebase from "firebase";
import router from './router'
// import Stripe from 'https://js.stripe.com/v3/'
const Stripe = window.Stripe;
export const gtag = window.gtag;
Vue.config.productionTip = false

import VueResource from 'vue-resource';

Vue.use(VueResource);

var config = {
  apiKey: "AIzaSyBWUUZYlufNOWPuKf8KWa_XEXX0jY5Ri5E",
  authDomain: "afgmtcom.firebaseapp.com",
  databaseURL: "https://afgmtcom.firebaseio.com",
  projectId: "afgmtcom",
  storageBucket: "afgmtcom.appspot.com",
  messagingSenderId: "1048626248238"
};
firebase.initializeApp(config);
export const db = firebase.firestore()
export const stripe = Stripe('pk_live_ZQEBwI3xSfsR3asgPd6Zd4JK00mQWyaVz3');
// export const stripe = Stripe('pk_test_nxIrhrDx2HjOHj7pZ0xHZ9I400lFwmK9WZ');


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
